module.exports = __webpack_public_path__ + "img/monitor.7eeb6217.svg";